export const MINT_CONTRACT_ADDRESS =
  '0x0169e971d146ccf8f5e88f2b12e2e6099663fb56e42573479f2aee93309982f8';

export const STRK_CONTRACT_ADDRESS =
  '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d';

export const CLASS_HASH =
  '0x05eaaf88061ca3230bba686a9296a3f54ee1c3ed2bc7879ae6d091c887d9dd94';
